import BrokerManagement from 'features/admin/brokerManagement/BrokerManagement';
import GroupManagementTable from 'features/admin/groupManagement/groupManagementTable';
import MdRenewalManagement from 'features/admin/mdRenewalManagement/MdRenewalManagement';
import RoleManagementTable from 'features/admin/roleManagement/roleManagementTable';
import TagManagementTable from 'features/admin/tagManagement/tagManagementTable';
import TenantAdminTable from 'features/admin/tenantAdmin/tenantAdminTable';
import TenantManagement from 'features/admin/tenantManagement/tenantManagement';
import UserPermissionTable from 'features/admin/userAccess/userPermissionTable';
import VendorLabelingTable from 'features/admin/vendor-labeling';
import VendorLabelingBrokerView from 'features/admin/vendor-labeling/brokerView';
import WhiteLabelingManagement from 'features/admin/white-labeling';
import BrokerWhiteLabelManagement from 'features/admin/white-labeling/BrokerWhiteLabelManagement';
import ActivationEngineNavigator from 'features/activationEngine/activationEngineNavigator';
import ClientPortalNavigator from 'features/clientPortal/clientPortalNavigator';
import AnnualPlanRenewal from 'features/clientPortal/components/AnnualPlanRenewal';
import ReportViewerDialogWrapper from 'features/frontoffice/component/ReportViewerDialogWrapper';
import CustomReport from 'features/frontoffice/customReport/customReport';
import ExclusiveReports from 'features/frontoffice/exclusiveReport';
import ExplorerReport from 'features/frontoffice/explorerReport/explorerReport';
import FavoriteReport from 'features/frontoffice/favoriteReport/favoriteReport';
import FrontOffice from 'features/frontoffice/index';
import ExistingReportTable from 'features/frontoffice/manageExisting/existingReportTable';
import ReportTable from 'features/frontoffice/manageReports/reportTable';
import Reports from 'features/frontoffice/reports';
import SmartCards from 'features/frontoffice/smartCards';
import SavedReport from 'features/frontoffice/saved/savedReport';
import StandardReport from 'features/frontoffice/standardReport';
import Applications from 'features/frontoffice/applications';
import Settings from 'features/frontoffice/settings';
import ConsolidatedReports from 'features/frontoffice/consolidatedReports';
import BstBars from 'features/landing/navigation/top/bstBars';
import AnnualHealthPlan from 'features/masterData/components/annualPlan/annualHealthPlan';
import DiscretionaryBenefits from 'features/masterData/components/discretionaryBenefits/discretionaryBenefits';
import Division from 'features/masterData/components/division/divsion';
import ElectionTier from 'features/masterData/components/electionTier/electionTier';
import EmployeeClass from 'features/masterData/components/employeeClass/employeClass';
import ElectionTierManagmentTable from 'features/masterData/components/lookup/component/electionTierManagementTable';
import Lookup from 'features/masterData/components/lookup/component/lookupTables';
import LookupTableNav from 'features/masterData/components/lookup/lookupTableNav';
import DentalPlan from 'features/masterData/components/planDesignData/dentalPlan';
import PlanDesignData from 'features/masterData/components/planDesignData/planDesignData';
import VisionPlan from 'features/masterData/components/planDesignData/visionPlan';
import PlanExpense from 'features/masterData/components/planExpense/PlanExpense';
import PlanRate from 'features/masterData/components/planRate/planRate';
import StopLossContract from 'features/masterData/components/stopLossContract/stopLossContract';
import { DiJobs } from 'features/masterData/DIJobs/DIJobs';
import Master from 'features/masterData/master';
import { MastersTable } from 'features/masterData/MastersTable';
import TenantRefreshDashboard from 'features/tenantRefresh/tenantRefreshDashboard';
import { Suspense } from 'react';
import { connect, useSelector } from 'react-redux';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import 'routes/appView.css';
import { hasPermission, isMatch } from 'utils/common';
import { AppConfig } from '../AppConfig';
import AdminNavigator from '../features/admin/navigation/adminNavigator';
import TenantAdminNavigator from '../features/admin/navigation/tenantAdminNavigator';
import TenantManagementNavigator from '../features/admin/navigation/tenantManagementNavigator';
import WhiteLabelNavigator from '../features/admin/navigation/whiteLabelingNavigator';
import TenantRefreshDataNavigator from '../features/tenantRefresh/tenantRefreshDataAdminNavigator';
import RouteConfig from './RouteConfig';
import routePaths from './routePaths';
import NewHome from '../features/landing/newHome/NewHome';
import SideNavBar from 'features/frontoffice/component/sideNavBar';
import CohortBuilder from '../features/cohortBuilder/CohortBuilder';
import { Box, CircularProgress, Skeleton } from '@mui/material';
import HiddenSmartCard from 'features/frontoffice/hiddenSmartCard';
import { ToastContainer } from 'react-toastify';
import { DRAWER_WIDTH, LEFT_NAV_DARK_BLUE, REPORT_URL_REGEX_PATTERNS } from 'common/Constant';
import { useFeatureFlag } from 'common/hooks/useFeatureFlag';
import { FEATURE_FLAG } from 'common/featureFlags';

export const AppShellLoading = ({ headerType }) => (
  <Box
    data-testid="app-shell-loading"
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label="Loading"
    sx={{
      position: 'fixed',
      inset: 0,
      bgcolor: '#FFFFFF',
      zIndex: (theme) => theme.zIndex.modal + 1,
      overflow: 'hidden',
      display: 'flex'
    }}>
    <Box
      sx={{
        width: `${DRAWER_WIDTH}px`,
        flexShrink: 0,
        bgcolor: LEFT_NAV_DARK_BLUE,
        px: 3,
        py: 3,
        boxSizing: 'border-box',
        display: { xs: 'none', md: 'flex' },
        flexDirection: 'column',
        gap: 3
      }}>
      {Array.from({ length: 2 }).map((_, idx) => (
        <Box key={`app-shell-nav-top-${idx}`} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
          <Skeleton variant="text" width="55%" height={20} sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
        </Box>
      ))}
      <Box sx={{ flexGrow: 1 }} />
      {Array.from({ length: 4 }).map((_, idx) => (
        <Box key={`app-shell-nav-bottom-${idx}`} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
          <Skeleton variant="text" width="60%" height={20} sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
        </Box>
      ))}
    </Box>

    <Box sx={{ flexGrow: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          height: '92px',
          flexShrink: 0,
          px: { xs: 2, sm: 6 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 2,
          borderBottom: '1px solid #959696',
          boxSizing: 'border-box'
        }}>
        {headerType === AppConfig.HEADER_MENU_TYPE.FO && (
          <>
            <Skeleton variant="rounded" width={96} height={40} sx={{ borderRadius: '24px' }} />
            <Skeleton variant="circular" width={40} height={40} />
          </>
        )}
      </Box>

      <Box sx={{ flexGrow: 1, overflow: 'hidden', p: { xs: 2, sm: 6 }, boxSizing: 'border-box' }}>
        <Box sx={{ display: 'flex', gap: 3, borderBottom: '1px solid #E0E0E0', pb: 1.5, mb: 3 }}>
          {Array.from({ length: 3 }).map((_, idx) => (
            <Skeleton
              key={`app-shell-tab-skeleton-${idx}`}
              variant="text"
              width={120}
              height={28}
            />
          ))}
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
          }}>
          <Skeleton variant="rounded" width={260} height={36} sx={{ borderRadius: '8px' }} />
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="circular" width={32} height={32} />
          </Box>
        </Box>

        <Box sx={{ border: '1px solid #E0E0E0', borderRadius: '8px', overflow: 'hidden' }}>
          <Box
            sx={{
              display: 'flex',
              gap: 3,
              p: 2,
              bgcolor: '#F5F5F5',
              borderBottom: '1px solid #E0E0E0'
            }}>
            {Array.from({ length: 4 }).map((_, idx) => (
              <Skeleton
                key={`app-shell-th-skeleton-${idx}`}
                variant="text"
                height={20}
                sx={{ flex: 1 }}
              />
            ))}
          </Box>
          {Array.from({ length: 8 }).map((_, rowIdx) => (
            <Box
              key={`app-shell-tr-skeleton-${rowIdx}`}
              sx={{
                display: 'flex',
                gap: 3,
                p: 2,
                borderBottom: rowIdx < 7 ? '1px solid #EEEEEE' : 'none'
              }}>
              {Array.from({ length: 4 }).map((_, cellIdx) => (
                <Skeleton
                  key={`app-shell-td-skeleton-${rowIdx}-${cellIdx}`}
                  variant="text"
                  height={18}
                  sx={{ flex: 1 }}
                />
              ))}
            </Box>
          ))}
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Skeleton variant="text" width={220} height={24} />
        </Box>
      </Box>
    </Box>
  </Box>
);

export const ActivationEngineRoute = ({ isAppReady, isUserAccessHydrated, showWorkdayFeature, canAccessActivationEngine, headerType }) => {
  if (!isAppReady) {
    return <AppShellLoading headerType={headerType} />;
  }
  if (!showWorkdayFeature || (isUserAccessHydrated && !canAccessActivationEngine)) {
    return <Navigate to={routePaths.frontOffice} replace />;
  }
  return <ActivationEngineNavigator />;
};

const AppView = () => {
  const showBstBarTenant = useSelector((state) => state.appState.showBstBarTenant);
  const {
    currentTenantCd: currentTenant,
    currentApp,
    permissions,
    companies,
    tenantApps,
    defaultUserState,
    isUpdating
  } = useSelector((state) => state.user);
  const isUserAccessHydrated = !defaultUserState && !isUpdating;
  const location = useLocation();
  const isAppReady = !!currentTenant;
  const openReportViewDialog = useSelector((state) => state.fo.openReportViewDialog);
  const isReportRoute = isMatch(location.pathname, REPORT_URL_REGEX_PATTERNS);
  const appError = useSelector((state) => state.appState.appError);
  const headerType = useSelector((state) => state.user.headerType);
  const showHideShelll = isReportRoute && !openReportViewDialog && !appError;
  const showWorkdayFeature = useFeatureFlag(FEATURE_FLAG.WORKDAY);
  const currentCompany = Array.isArray(companies)
    ? companies.find((company) => company?.code === currentTenant)
    : null;
  const canAccessActivationEngine =
    showWorkdayFeature &&
    !!currentCompany?.campaignEnabled &&
    tenantApps?.includes(AppConfig.APP_CODE_ACTIVATION_ENGINE);

  return (
    <div>
      <Suspense fallback={<h1>loading...</h1>}>
        {!isAppReady && !showHideShelll && <AppShellLoading headerType={headerType} />}
        <Box sx={{visibility: isAppReady && !showHideShelll ? 'visible' : 'hidden' }}>
          <BstBars showBstBarTenant={showBstBarTenant} />
          <SideNavBar currentTenantCd={currentTenant} />
          <Box
            component="main"
            className="site-main"
            sx={{
              backgroundColor: '#FFFFFF',
              marginTop: {
                xs: 'calc(80px + var(--active-filters-banner-height, 0px))',
                md: 'calc(92px + var(--active-filters-banner-height, 0px))',
              },
              marginLeft: { xs: 0, md: `${DRAWER_WIDTH}px` },
            }}
          >
            <Routes>
              <Route
                path={`${routePaths.frontOffice}/*`}
                element={
                  <Box>
                    {' '}
                    <FrontOffice />
                    <Outlet />
                  </Box>
                }>
                <Route path="" element={hasPermission(AppConfig.PERMISSION.FO_REPORT_HOME, permissions) && <Reports />} />
                <Route path=":tenantCd/view/:workbook/:dashboard" element={<ReportViewerDialogWrapper />} />
                <Route index element={<NewHome />} />
                <Route path="smart-cards/*" element={hasPermission(AppConfig.PERMISSION.FO_SMART_CARD_VIEW, permissions) ? <SmartCards /> : <Navigate to={routePaths.frontOffice} replace />} />
                <Route path="reports/*" element={<ConsolidatedReports />} />
                <Route path="hidden-smart-card/*" element={<HiddenSmartCard />} />
                <Route path="addReports/*" element={<ReportTable />} />
                <Route path="manageReports/*" element={<ExistingReportTable />} />
                <Route path="applications" element={<Applications />} />
                <Route path="settings" element={<Settings />} />
                <Route
                  path={`${AppConfig.FRONT_OFFICE_SUB_URL.STANDARD}/*`}
                  element={
                    <>
                      {hasPermission(AppConfig.PERMISSION.FO_STANDARD_REPORT, permissions) ? <StandardReport /> : <></>}
                      <Outlet />
                    </>
                  }>
                  <Route path=":tenantCd/view/:workbook/:dashboard" element={<ReportViewerDialogWrapper />} />
                </Route>
                <Route
                  path={`${AppConfig.FRONT_OFFICE_SUB_URL.MY_REPORT}/*`}
                  element={
                    <>
                      <SavedReport />
                      <Outlet />
                    </>
                  }>
                  <Route path=":tenantCd/view/:workbook/:dashboard" element={<ReportViewerDialogWrapper />} />
                </Route>
                <Route
                  path={`${AppConfig.FRONT_OFFICE_SUB_URL.MY_FAVORITE}/*`}
                  element={
                    <>
                      <FavoriteReport />
                      <Outlet />
                    </>
                  }>
                  <Route path=":tenantCd/view/:workbook/:dashboard" element={<ReportViewerDialogWrapper />} />
                </Route>
                <Route
                  path={`${AppConfig.FRONT_OFFICE_SUB_URL.EXPLORER}/*`}
                  element={
                    <>
                      {hasPermission(AppConfig.PERMISSION.FO_EXPLORER_REPORT, permissions) ? <ExplorerReport /> : <></>}
                      <Outlet />
                    </>
                  }>
                  <Route path=":tenantCd/view/:workbook/:dashboard" element={<ReportViewerDialogWrapper />} />
                </Route>
                <Route
                  path={`${AppConfig.FRONT_OFFICE_SUB_URL.EXCLUSIVE}/*`}
                  element={
                    <>
                      {hasPermission(AppConfig.PERMISSION.FO_EXCLUSIVE_REPORTS, permissions) ? <ExclusiveReports /> : <></>}
                      <Outlet />
                    </>
                  }>
                  <Route path=":tenantCd/view/:workbook/:dashboard" element={<ReportViewerDialogWrapper />} />
                </Route>
                <Route
                  path={`${AppConfig.FRONT_OFFICE_SUB_URL.MY_CUSTOM}/*`}
                  element={
                    <>
                      {hasPermission(AppConfig.PERMISSION.FO_CUSTOM_REPORT, permissions) ? <CustomReport /> : <></>}
                      <Outlet />
                    </>
                  }>
                  <Route path=":tenantCd/view/:workbook/:dashboard" element={<ReportViewerDialogWrapper />} />
                </Route>
                <Route
                  path={AppConfig.FRONT_OFFICE_SUB_URL.REPORT_MANAGEMENT}
                  element={
                    <>
                      {hasPermission(AppConfig.PERMISSION.FO_REPORT_MANAGEMENT, permissions) ? <ReportTable /> : <></>}
                      <Outlet />
                    </>
                  }>
                  <Route path=":tenantCd/view/:workbook/:dashboard" element={<ReportViewerDialogWrapper />} />
                </Route>
                <Route
                  path={AppConfig.FRONT_OFFICE_SUB_URL.EXISTING_REPORTS}
                  element={
                    <>
                      {hasPermission(AppConfig.PERMISSION.FO_REPORT_MANAGEMENT, permissions) ? <ExistingReportTable /> : <></>}
                      <Outlet />
                    </>
                  }>
                  <Route path=":tenantCd/view/:workbook/:dashboard" element={<ReportViewerDialogWrapper />} />
                </Route>
                <Route path="*" element={<Navigate to={routePaths.frontOffice} replace />} />
              </Route>

              <Route path={routePaths.newHome} element={<RouteConfig.newHome.component />} />

              <Route
                path={`${routePaths.master}`}
                element={
                  <>
                    <Master />
                    {/* The master data backend rejects a front-office JWT, so the
                        child pages must not mount until the MASTER_DATA tenant
                        switch has minted a token for them. */}
                    {currentApp === AppConfig.APP_CODE_MASTER_DATA ? (
                      <Outlet />
                    ) : (
                      <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
                        <CircularProgress aria-label="Loading master data" />
                      </Box>
                    )}
                  </>
                }>
                <Route path={AppConfig.MASTER_DATA_SUB_URL.MASTER_TABLE} element={<MastersTable />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.ET_SCHEMA} element={<ElectionTier tenantId={currentTenant} />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.DENTAL_PLAN} element={<DentalPlan tenantId={currentTenant} />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.VISION_PLAN} element={<VisionPlan tenantId={currentTenant} />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.PLAN_EXPENSE} element={<PlanExpense />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.PLAN_RATES} element={<PlanRate tenantId={currentTenant} />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.DIVISION} element={<Division tenantId={currentTenant} />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.EMPLOYEE_CLASS} element={<EmployeeClass tenantId={currentTenant} />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.ANNUAL_HEALTH_PLAN} element={<AnnualHealthPlan tenantId={currentTenant} />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.PLAN_DESIGN_DATA} element={<PlanDesignData tenantId={currentTenant} />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.DISCRETIONARY_BENEFITS} element={<DiscretionaryBenefits tenantId={currentTenant} />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.STOP_LOSS_CONTRACT} element={<StopLossContract />} />
                <Route path={AppConfig.MASTER_DATA_SUB_URL.DI_JOBS} element={<DiJobs />} />
                <Route path="*" element={<Navigate to={`${routePaths.master}/${AppConfig.MASTER_DATA_SUB_URL.MASTER_TABLE}`} replace />} />
              </Route>

              <Route path={routePaths.lookup} element={<LookupTableNav />}>
                <Route path={AppConfig.LOOKUP_TABLES_SUB_URL.LOOKUP} element={<Lookup />} />
                <Route path={AppConfig.LOOKUP_TABLES_SUB_URL.ELECTION_TIER_LIST} element={<ElectionTierManagmentTable />} />
                <Route path="*" element={<Navigate to={`${routePaths.lookup}/${AppConfig.LOOKUP_TABLES_SUB_URL.LOOKUP}`} replace />} />
              </Route>

            <Route path={routePaths.clientTable} element={<RouteConfig.clientTable.component />} />

              <Route path={routePaths.tenantRefresh} element={<TenantRefreshDataNavigator />}>
                <Route path="" element={<TenantRefreshDashboard />} />
                <Route path="*" element={<Navigate to={routePaths.tenantRefresh} replace />} />
              </Route>

              <Route path={routePaths.tenantAdmin} element={<TenantAdminNavigator />}>
                <Route path="" element={<TenantAdminTable />} />
                <Route path="*" element={<Navigate to={routePaths.tenantAdmin} replace />} />
              </Route>

              <Route path={routePaths.tenantManagement} element={<TenantManagementNavigator />}>
                <Route path={AppConfig.TENANT_MANAGEMENT_SUB_URL.TENANT} element={<TenantManagement />} />
                <Route path={AppConfig.TENANT_MANAGEMENT_SUB_URL.BROKER} element={<BrokerManagement />} />
                <Route path={AppConfig.TENANT_MANAGEMENT_SUB_URL.MD_RENEWAL_MGMT} element={<MdRenewalManagement />} />
                <Route path="*" element={<Navigate to={`${routePaths.tenantManagement}/${AppConfig.TENANT_MANAGEMENT_SUB_URL.TENANT}`} replace />} />
              </Route>

              <Route path={routePaths.clientPortal + AppConfig.CLIENT_PORTAL_SUB_URL.ANNUAL_PLAN_RENEWAL} element={<ClientPortalNavigator />}>
                <Route path="" element={<AnnualPlanRenewal />} />
                <Route path="*" element={<Navigate to={`${routePaths.clientPortal}/${AppConfig.CLIENT_PORTAL_SUB_URL.ANNUAL_PLAN_RENEWAL}`} replace />} />
              </Route>

              <Route
                path={`${routePaths.activationEngine}/*`}
                element={
                  <ActivationEngineRoute
                    isAppReady={isAppReady}
                    isUserAccessHydrated={isUserAccessHydrated}
                    showWorkdayFeature={showWorkdayFeature}
                    canAccessActivationEngine={canAccessActivationEngine}
                    headerType={headerType}
                  />
                }
              />

              <Route path={routePaths.clientPortalQuestionary} element={<RouteConfig.clientPortalQuestionary.component />} />

              <Route path={routePaths.whiteLabeling} element={<WhiteLabelNavigator />}>
                <Route path={AppConfig.WHITE_LABEL_SUB_URL.WHITE_LABEL} element={<WhiteLabelingManagement />} />
                <Route path={AppConfig.WHITE_LABEL_SUB_URL.WHITE_LABEL_BROKER} element={<BrokerWhiteLabelManagement />} />
                <Route path={AppConfig.WHITE_LABEL_SUB_URL.VENDOR_LABELING} element={<VendorLabelingTable />} />
                <Route path={AppConfig.WHITE_LABEL_SUB_URL.VENDOR_LABELING_BROKER_VIEW} element={<VendorLabelingBrokerView />} />
                <Route path={AppConfig.WHITE_LABEL_SUB_URL.TAG_MANAGEMENT} element={<TagManagementTable />} />
                <Route path="*" element={<Navigate to={`${routePaths.whiteLabeling}/${AppConfig.WHITE_LABEL_SUB_URL.WHITE_LABEL}`} replace />} />
              </Route>

              <Route path={routePaths.adminPage} element={<AdminNavigator />}>
                <Route path="" element={<UserPermissionTable />} />
                <Route path={AppConfig.ADMIN_SUB_URL.ROLE_MANAGEMENT} element={<RoleManagementTable />} />
                <Route path={AppConfig.ADMIN_SUB_URL.USER_GROUP} element={<GroupManagementTable />} />
                <Route path="*" element={<Navigate to={routePaths.adminPage} replace />} />
              </Route>

              <Route path={routePaths.reportDefaultSetting} element={<RouteConfig.reportDefaultSetting.component />} />
              <Route path={routePaths.cohortBuilder} element={<CohortBuilder />} />
              <Route path="*" element={<Navigate to={routePaths.newHome} replace />} />
            </Routes>
          </Box>
        </Box>
      </Suspense>
      <ToastContainer />
    </div>
  );
};
const mapStateToPropsSelector = createStructuredSelector({
  appError: (state) => state.appState.appError
});
export default connect(mapStateToPropsSelector)(AppView);
